import { useEffect } from "react";
import { mediaUrl } from "@/lib/api";

const setTag = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

const setJsonLd = (id, obj) => {
  let el = document.getElementById(id);
  if (!el) { el = document.createElement("script"); el.type = "application/ld+json"; el.id = id; document.head.appendChild(el); }
  el.textContent = JSON.stringify(obj);
};

// SEO: sets <title>, meta description, OG tags and optional JSON-LD structured data.
export const useSEO = ({ title, description, image, jsonLd } = {}) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) { setTag("name", "description", description); setTag("property", "og:description", description); }
    if (title) setTag("property", "og:title", title);
    const img = image ? mediaUrl(image) : null;
    if (img) { setTag("property", "og:image", img); setTag("name", "twitter:image", img); }
    setTag("property", "og:url", window.location.href);
    if (jsonLd) setJsonLd("nba-jsonld", jsonLd);
    return () => { const el = document.getElementById("nba-jsonld"); if (el) el.remove(); };
  }, [title, description, image, jsonLd]);
};
